<template>
  <div id="app">
    <AppHeader />
    <router-view />
    <AppFooter />
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  box-sizing: border-box;
}
body,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
dl,
dd,
dt,
li,
p {
  padding: 0;
  margin: 0;
}
body {
  min-width: 100%;
  margin: 0 auto;
}
input,
button {
  outline: none;
  border: none;
}
a {
  text-decoration: none;
  color: #000;
}
a:hover {
  text-decoration: none;
  color: initial;
}

li,
i {
  list-style: none;
}

img {
  width: auto;
  border: 0 none;
  vertical-align: middle;
  border: 0 none;
}
</style>
